var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "standard_bottle",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m47.588,13.727v13.257c0,2.458-.604,4.878-1.759,7.048l-1.72,3.231c-.747,1.403-1.293,2.905-1.623,4.46h0c-.319,1.503-.479,3.035-.479,4.571v39.802c0,1.312,1.064,2.376,2.376,2.376h12.739c1.312,0,2.376-1.064,2.376-2.376v-39.802c0-1.536-.161-3.068-.479-4.571h0c-.33-1.555-.876-3.056-1.623-4.46l-1.72-3.231c-1.155-2.17-1.759-4.59-1.759-7.048v-13.257c0-.552-.448-1-1-1h-4.329c-.552,0-1,.448-1,1Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }